import React from 'react';
import PropTypes from 'prop-types';
import GasIcon from '../../icons/icon-commodity-gas.svg';
import ElectricIcon from '../../icons/icon-commodity-electric.svg';
import CombinedIcon from '../../icons/icon-commodity-combined.svg';
import BookmarkIcon from '../../icons/icon-rebate-bookmark.svg';


const CommodityIcon = function CommodityIcon({ className, commodityValue }) {
  const commodityIconMap = {
    gas: GasIcon,
    electric: ElectricIcon,
    combined: CombinedIcon,
  };

  const CurrentIcon = commodityValue ? commodityIconMap[commodityValue] : BookmarkIcon;

  return (
    <CurrentIcon className={className} />
  );
};

CommodityIcon.propTypes = {
  className: PropTypes.string.isRequired,
  commodityValue: PropTypes.string,
};

CommodityIcon.defaultProps = {
  commodityValue: null,
};

export default CommodityIcon;
